import { Injectable } from '@angular/core';
import { AboutDialogService } from '@mri-platform/import-export/common-ui';
import { AppRoutes } from '@mri-platform/import-export/core';
import { MainMenuItemService } from '@mri-platform/shared/shell';
import { DrawerMenuItem, LinkMenuItem, ModalMenuItem } from '@mri-platform/shared/ui-main-nav-bar';

@Injectable()
export class AppMainMenuItemService implements MainMenuItemService {
  private home: LinkMenuItem = {
    iconName: 'home',
    title: 'Home',
    ...AppRoutes.RecentImportExport.toMenuInfo()
  };

  private jobs: LinkMenuItem = {
    iconName: 'swap_horiz',
    title: 'Jobs',
    ...AppRoutes.ImportExportJobs.toMenuInfo()
  };

  private mappings: LinkMenuItem = {
    iconName: 'schema',
    title: 'Mapping manager',
    ...AppRoutes.MappingManager.toMenuInfo()
  };

  private help: LinkMenuItem = {
    iconName: 'help_outline',
    title: 'User guide',
    url: 'assets/user-guide.html',
    opener: (url: string) => window.open(url, '_blank'),
    cssClass: ['help-center-icon']
  };

  private mriSettings: DrawerMenuItem = {
    iconName: 'settings',
    title: 'Administration',
    links: [
      { text: 'Applications and data sources', ...AppRoutes.PlatformManagement.toMenuInfo() },
      { text: 'Connection management', ...AppRoutes.MappingConnections.toMenuInfo() },
      { text: 'User security settings', ...AppRoutes.UserSecuritySettings.toMenuInfo() },
      { text: 'Client management', ...AppRoutes.ClientManagement.toMenuInfo() }
    ],
    cssClass: ['administration-icon']
  };

  private about: ModalMenuItem = {
    iconName: 'information-circle-outlined',
    title: 'About',
    cssClass: ['about-icon'],
    open: () => {
      this.aboutDialogService.openAboutDialog();
    }
  };

  get items() {
    return [this.home, this.jobs, this.mappings, this.help, this.mriSettings, this.about];
  }

  constructor(private aboutDialogService: AboutDialogService) {}
}
